export default __webpack_public_path__ + "static/media/step_003.df52d635.png";